export default __webpack_public_path__ + "static/media/security.74c136e2.png";